module.exports = __webpack_public_path__ + "static/Canela-Black-48e3e490ca73b2cee3e3af70bfbc3f1c.otf";